module.exports = __webpack_public_path__ + "img/module_online.95e59cd3.jpg";